import { RouteService } from './RouteService';

export function AppServices() {
    return (
        <>
            <RouteService />
        </>
    );
}
